var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goalsAdmin"},[_c('h1',{staticClass:"goalsAdmin__title"},[_vm._v("Lista de modelos")]),_vm._l((_vm.asignedModels),function(model){return _c('ModelGoalsPanel',{key:model._id,attrs:{"model":model}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }